import { register } from "@shared/services/propertyRendererRegistry";
import StatusTagRenderer from "@shared/components/tickets/components/StatusTagRenderer.vue";
import StatusSelectEditor from "@shared/components/tickets/components/StatusSelectEditor.vue";
import PriorityTagRenderer from "@shared/components/tickets/components/PriorityTagRenderer.vue";
import PrioritySelect from "@shared/components/tickets/components/PrioritySelect.vue";

register({
  twinTypePattern: "tm.ticket.*",
  customId: "status",
  viewComponentTable: StatusTagRenderer,
  viewComponentDetail: StatusTagRenderer,
  editComponent: StatusSelectEditor,
});

register({
  twinTypePattern: "tm.ticket.*",
  customId: "priority",
  viewComponentTable: PriorityTagRenderer,
  viewComponentDetail: PriorityTagRenderer,
  editComponent: PrioritySelect,
});
